export default "__VITE_ASSET__QH683X81__"